import { useState } from 'react'

import { Button } from '@material-ui/core'
import { ConfirmationDialog, Permitted } from 'components'

import constants from 'constants/index'
import helpers from 'helpers'

import PropTypes from 'prop-types'
import * as service from 'service'

import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'

import useSnackbar from 'hooks/useSnackbar'

const RemoveSegment = ({ segmentId, refresh, isEdit }) => {
  const history = useHistory()
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const snackbar = useSnackbar()
  const deleteMessage = 'Deseja realmente excluir o segmento?'

  const handleDelete = async () => {
    try {
      await service.dponet.segments.destroy({ segmentId })

      if (isEdit) {
        history.push(routes.segments.all)
      } else {
        refresh()
      }

      snackbar.open({
        message: 'Segmento excluido com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao excluir o segmento!',
      })
    }
    setOpenDeleteDialog(false)
  }

  return (
    <>
      <Permitted tag={constants.permissions.SEGMENTS.DESTROY}>
        <Button
          fullWidth
          size="small"
          onClick={() => setOpenDeleteDialog(true)}
        >
          Excluir
        </Button>
      </Permitted>
      <ConfirmationDialog
        open={openDeleteDialog}
        setOpen={setOpenDeleteDialog}
        message={deleteMessage}
        cancelButtonText="Cancelar"
        buttonText="Excluir"
        actionAcceptButton={handleDelete}
      />
    </>
  )
}

RemoveSegment.propTypes = {
  segmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEdit: PropTypes.bool,
  refresh: PropTypes.func,
}

RemoveSegment.defaultProps = {
  isEdit: false,
  refresh: () => {},
}

export default RemoveSegment
